import { ClickableList, Row } from '@cdab/scania/qpr/components'
import { TdsButton, TdsDropdown } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledEndRow = styled(Row)`
  display: flex;
  justify-content: flex-end;
`

export const StyledClickableList = styled(ClickableList)`
  overflow: hidden;
  margin-top: 0;
  margin-bottom: 8px;
`

export const StyledFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTdsButton = styled(TdsButton)`
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  button {
    display: block !important;
  }
`

export const Title = styled.h3.attrs({
  className: 'tds-headline-03'
})``

export const StyledMainRow = styled(Row)`
  display: flex;

  @media (max-width: ${({ theme }) => theme.size.xlg}) {
    flex-direction: column;
  }

  @media (min-width: ${({ theme }) => theme.size.xlg}) {
    flex-direction: row;
  }
`

export const StyledDropdown = styled(TdsDropdown)`
  margin-bottom: 16px;
`
